/* unplugin-vue-components disabled */import script from "./ActivityEditRecordDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityEditRecordDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ActivityEditRecordDetailModal.vue?vue&type=style&index=0&id=577c7f9a&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-577c7f9a"]])

export default __exports__